import { HelpArticle } from "@/features/Page/types/page";

export const helpArticles: HelpArticle[] = [
  {
    title: 'About Translator',
    slug: 'about-translator'
  },
  {
    title: 'How to Use Translator',
    slug: 'how-to-use-translator'
  },
  {
    title: 'Submitting Queries',
    slug: 'submitting-queries'
  },
  {
    title: 'Loading and Syncing',
    slug: 'loading-and-syncing'
  },
  {
    title: 'Paths and Graphs',
    slug: 'paths-and-graphs'
  },
  {
    title: 'Relationship Evidence',
    slug: 'relationship-evidence'
  },
  {
    title: 'Sorting and Filtering', 
    slug:'sorting-and-filtering'
  },
  {
    title: 'Bookmarks and Notes',
    slug: 'bookmarks-and-notes'
  },
  {
    title: 'Sharing Results',
    slug: 'sharing-results'
  },
  {
    title: 'Projects',
    slug: 'projects-article'
  },
  {
    title: 'Query History',
    slug: 'query-history-article'
  },
  {
    title: 'Account and Settings',
    slug: 'account-and-settings'
  },
  {
    title: 'Frequently Asked Questions', 
    slug:'frequently-asked-questions'
  },
  {
    title: 'Security and Privacy', 
    slug:'security-and-privacy'
  },
];